import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';

import { environment } from '../../environments/environment';
import { CourseType } from '../models/course-type.model';

@Injectable({
  providedIn: 'root',
})
export class CourseTypeService {
  private apiUrl = environment.apiUrl + '/CourseType';

  http = inject(HttpClient);

  private courseTypesCache: CourseType[] = null;
  private courseTypesSubject = new BehaviorSubject<CourseType[]>(null);

  addCourseType(courseType: CourseType): void {
    if (this.courseTypesCache) {
      this.courseTypesCache = [...this.courseTypesCache, courseType];
    } else {
      this.courseTypesCache = [courseType];
    }
  }

  getCourseTypeObservable(): Observable<CourseType[]> {
    return this.courseTypesSubject.asObservable();
  }

  getCourseTypes(): Observable<CourseType[]> {
    if (!this.courseTypesCache) {
      this.http
        .get<CourseType[]>(`${this.apiUrl}/GetAllCourseTypes`)
        .pipe(
          tap((courseTypes) => {
            this.courseTypesCache = courseTypes;
            this.courseTypesSubject.next(courseTypes);
          })
        )
        .subscribe();
    }
    return this.getCourseTypeObservable();
  }

  createCourseType(courseType: CourseType): Observable<CourseType> {
    return this.http
      .post<CourseType>(`${this.apiUrl}/CreateCourseType`, courseType)
      .pipe(
        tap((newCourseType) => {
          this.addCourseType(newCourseType);
          this.courseTypesSubject.next(this.courseTypesCache);
        })
      );
  }

  deleteCourseType(courseType: CourseType): Observable<any> {
    return this.http.delete(
      `${this.apiUrl}/DeleteCourseType/${courseType.courseTypeId}`
    );
  }

  updateCourseType(courseType: CourseType): Observable<any> {
    return this.http.put(
      `${this.apiUrl}/UpdateCourseType/${courseType.courseTypeId}`,
      courseType
    );
  }
}
